<template>
  <form
    @submit.prevent="submit"
  >
  
    <material-input
      id="new-group-title"
      v-model="title"
      label="Titel groep"
      class="mb-4"
    />

    <dropdown
      label="Gebruiker toevoegen"
      :options="dropdownOptions"
      @option-selected="onOptionSelected"
    />

    <div
      class="users"
    >
      <group-form-user
        v-for="option in filteredOptions"
        :key="option.value"
        :user-id="option.value"
        :user-name="option.label"
        :image-url="option.image"
        @deleted="onUserDeleted"
      />
    </div>

    <material-button
      class="float-end"
      color="primary"
    >
      Groep aanmaken
    </material-button>
  </form>
</template>

<script>
import { mapActions } from 'vuex';

import Dropdown from '@/components/UI/Dropdown.vue';
import MaterialButton from '@/components/MaterialButton.vue';
import MaterialInput from '@/components/MaterialInput.vue';

import GroupFormUser from './GroupFormUser.vue';

import { addGroup } from '@/api/providers/groups';

export default {
  components: {
    Dropdown,
    GroupFormUser,
    MaterialButton,
    MaterialInput
  },

  props: {
    dropdownOptions: { type: Array, required: true }
  },

  emits: [
    'submit'
  ],

  data() {
    return {
      title: '',
      selectedOptions: [],
    }
  },

  computed: {
    filteredOptions() {
      return this.selectedOptions.filter(o => !o.isDeleted);
    }
  },

  methods: {
    ...mapActions('notification', {
      addNotification: 'add',
    }),

    async submit() {
      const newUserIds = 
        this.selectedOptions.filter(u => u.isNew && !u.isDeleted).map(u => u.value);

      try {
        await addGroup(this.title, newUserIds);

        this.addNotification({
          description: `Groep ${this.title} is aangemaakt.`,
          icon: {
            component: 'group_add',
          },
        });
        
        this.$emit('submit');
      }
      catch { 
        this.addNotification({
          description: `Er was een fout bij het aanmaken van de groep ${this.title}.`,
          icon: {
            component: 'cancel',
          },
        });
      }
    },

    onUserDeleted(userId) {
      const optionIndex = this.selectedOptions.findIndex(o => o.value === userId);
      if (optionIndex < 0) return;

      this.selectedOptions[optionIndex] = { ...this.selectedOptions[optionIndex], isDeleted: true };
    },

    onOptionSelected(option) {
      this.selectedOptions.push({ ...option, isNew: true });
    }
  }
}
</script>